import { ApolloClient } from "apollo-client";
import { ApolloLink } from "apollo-link";
import QueueLink from "apollo-link-queue";
import { HttpLink } from "apollo-link-http";
import { RetryLink } from "apollo-link-retry";
import { InMemoryCache } from "apollo-cache-inmemory";
import { onError } from 'apollo-link-error';
import store from '@/store';
import { logErrorMessages } from '@vue/apollo-util';

const errorLink = onError(error => {
  if (error.networkError && error.networkError.statusCode === 403) {
    store.dispatch('logout');
  } else {
    logErrorMessages(error);
  }
});

const httpEndpoint = process.env.VUE_APP_GRAPHQL_HTTP;

const httpLink = new HttpLink({
  uri: httpEndpoint,
  credentials: "include",
});

const queueLink = new QueueLink();

const retryLink = new RetryLink({
  // eslint-disable-next-line no-unused-vars
  attempts: (count, operation, error) => {
    return true;
  },
  // eslint-disable-next-line no-unused-vars
  delay: (count, operation, error) => {
    return count * 1000;
  },
});

// eslint-disable-next-line no-unused-vars
window.addEventListener("online", (event) => {
  // eslint-disable-line no-unused-vars
  queueLink.open();
});

// eslint-disable-next-line no-unused-vars
window.addEventListener("offline", (event) => {
  queueLink.close();
});

const link = ApolloLink.from([queueLink, retryLink, errorLink, httpLink]);

const apolloClient = new ApolloClient({
  link: link,
  cache: new InMemoryCache(),
  // connectToDevTools: true
});

export default apolloClient;
